import { render, staticRenderFns } from "./doctorManageDel.vue?vue&type=template&id=35d91aca&scoped=true"
import script from "./doctorManageDel.vue?vue&type=script&lang=js"
export * from "./doctorManageDel.vue?vue&type=script&lang=js"
import style0 from "./doctorManageDel.vue?vue&type=style&index=0&id=35d91aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d91aca",
  null
  
)

export default component.exports